import { render, staticRenderFns } from "./SpinControlPanel.vue?vue&type=template&id=7c32b019&scoped=true&"
import script from "./SpinControlPanel.vue?vue&type=script&lang=js&"
export * from "./SpinControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpinControlPanel.vue?vue&type=style&index=0&id=7c32b019&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c32b019",
  null
  
)

export default component.exports